import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { setUser, useGetUserQuery } from 'common'

import { useDeleteAvailabilityScheduleMutation, useGetAvailabilitySchedulesQuery } from '../../../api'
import { pushHrefPreservingSearchExcept, useSchedulesRoutes } from '../../schedules_routes_context'

export const DeleteSchedulePopup = ({ selectedScheduleId }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const schedulesRoutes = useSchedulesRoutes()
  const { data: { primary_availability_rule_id: defaultScheduleId } } = useGetUserQuery()
  const { data: allSchedules } = useGetAvailabilitySchedulesQuery()

  const [deleteAvailabilitySchedule] = useDeleteAvailabilityScheduleMutation()

  const selectedSchedule = allSchedules.find(({ id: scheduleId }) => scheduleId === selectedScheduleId)

  const handleClose = () => pushHrefPreservingSearchExcept(history, ['delete'])

  const handleConfirm = () => {
    deleteAvailabilitySchedule({
      id: selectedScheduleId,
      onSuccess: () => {
        if (selectedScheduleId === defaultScheduleId) {
          const newDefaultSchedule = allSchedules.find(({ id: scheduleId }) => scheduleId !== defaultScheduleId)

          dispatch(setUser({ primary_availability_rule_id: newDefaultSchedule.id }))
        }

        history.push(schedulesRoutes.invalidRedirectHref())
      }
    })
  }

  return (
    <SimplePopup
      isDestructive
      title={I18n.t('publisher.availability.schedules.delete_popup.title', { schedule: selectedSchedule.name })}
      confirmLabel={I18n.t('publisher.availability.schedules.delete_popup.confirm')}
      cancelLabel={I18n.t('publisher.action.cancel')}
      onConfirm={handleConfirm}
      onClose={handleClose}
    >
      <div>
        {HtmlParser(I18n.t('publisher.availability.schedules.delete_popup.body'))}
      </div>
    </SimplePopup>
  )
}
